module.exports = [
    { value: 'oe1.orf.at_breakingNews',     label: 'Breaking News' },
];
